import React, { memo, useState, useEffect } from 'react'
import { 
    TextField, Grid, Button, Stack, 
    Box, Avatar, Paper, Container, 
    Typography, CircularProgress, Chip,
    Fab, useTheme, Hidden, Divider, 
    Switch, FormControlLabel, ListItemSecondaryAction, IconButton,  
} from '@mui/material';
import { format, parseISO } from 'date-fns';
import { List, ListItem, ListItemText, ListItemAvatar, ListItemIcon } from '@mui/material';
//import { CardContent, CardActions, Card,} from '@mui/material';
import Select from 'react-select';
import { Menu, MenuItem } from '@mui/material';
import { useForm, Controller  } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { formatarParaSelect } from '../utils/utils';
import { useSelector, useDispatch } from 'react-redux';
import { useDebounce } from 'react-use';

// Actions para lidar com esta rota 
import { 
    manutencaoSetDrawer, // Action para determinar o drawer a ser exibido
    manutencaoUsuariosAtualizarSenha, manutencaoUsuariosGetInit, 
    manutencaoUsuariosGestaoUsuario, manutencaoUsuariosExcluirUsuario,
    manutencaoUsuariosAdicionarUsuario,
    manutencaoRegioesGetInit, // Busca todos os dados necessarios para manipular as regioes
    manutencaoRegioesAddUpdRegiaoLocalidade, // Para adicionar uma nova localidade
    manutencaoRegioesDelRegiaoLocalidade, // Para excluir uma localidade
    manutencaoRegioesAddRegiao, // Para incluir temporariamente uma nova regiao
    manutencaoVariaveisAddUpdVariavel, // Para adicionar uma nova variavel
    manutencaoVariaveisUpdValor, // Para atualizar o valor das variaveis
    manutencaoVariaveisDelVariavel, // Para excluir uma variavel
    manutencaoVariaveisGetInit, // Para recuperar os dados referentes as variaveis
    manutencaoCargoGetInit, // Para obter os cargos
    manutencaoCargoAddUpd, // Para adicionar ou atualizar um cargo existente
    manutencaoCargoDel, // Para excluir um cargo existente
} from '../redux/actions';
//
import BlockIcon from '@mui/icons-material/Block';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import DeleteIcon from '@mui/icons-material/Delete';
import SaveIcon from '@mui/icons-material/Save';
import EmailIcon from '@mui/icons-material/Email';
import PersonIcon from '@mui/icons-material/Person';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import PlaceIcon from '@mui/icons-material/Place';
import SearchIcon from '@mui/icons-material/Search';
import EditLocationAltIcon from '@mui/icons-material/EditLocationAlt';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AddLocationIcon from '@mui/icons-material/AddLocation';
import MediationIcon from '@mui/icons-material/Mediation';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import EngineeringIcon from '@mui/icons-material/Engineering';

//
import { Dialog, Drawer, Tab, Paginacao } from '../components';


import { toast, ToastContainer } from 'react-toastify';
// Criar um schema validador da senha
const schema = yup.object().shape({
    senha: yup.string().min(6).required(),
    confirmarSenha: yup.string().min(6).required(),
});
const schema2 = yup.object().shape({
    email: yup.string().email().required(),
    nome: yup.string().min(6).required(),
    senha: yup.string().min(6).required(),
});
// Componente a ser exibido no select quando não se encontrar os valores
const NoOptionsMessage = (props) => {
    const dispatch = useDispatch();
    
    return (
        <Stack direction='row' justifyContent='center'>
            <Button fullWidth 
                onClick={()=> dispatch(manutencaoRegioesAddRegiao(props.selectProps.inputValue))} 
                startIcon={<AddLocationIcon />} title='Clique para adicionar a nova localidade'
            >
                ADICIONAR
            </Button>
        </Stack>
      
    );
  };

 // Estilização do componente select
 const selectStyles = {
    multiValueRemove: (styles)=> ({
        ...styles,
        color: 'black',
    }),
    option: (styles)=>({
        ...styles,
        color: 'black',
    }),
}
// Criacao do schema para validar a adicao de local
const schemaAddLocal = yup.object().shape({
    localidade: yup.string().min(3).required(),
    regiao: yup.object().shape({
        key: yup.string().min(1).required(),
        label: yup.string().min(1).required(),
        value: yup.string().min(1).required(),
    }).required(),
});
// Criacao do schema para validar a atualização de uma opção nas variaveis
const schemaUpdVariavel = yup.object().shape({
    valor: yup.object().shape({
        key: yup.string().min(1).required(),
        label: yup.string().min(1).required(),
        value: yup.string().min(1).required(),
    }).required(),
});
// Criacao do schema para validar a adicao/edicao de cargo
const schemaAddCargo = yup.object().shape({
    cargo: yup.string().min(1).required(),
});
// Este objeto e usado para definir qual drawer deve ser chamado quando algum recurso for selecionado/escolhido
const VALORES_DRAWER = {
    ALTERAR_SENHA: 'ALTERAR_SENHA',
    ADD_USUARIO: 'ADD_USUARIO',
    INTENCAO_ADD_REGIAO_LOCALIDADE: 'INTENCAO_ADD_REGIAO_LOCALIDADE',
    INTENCAO_ADD_VARIAVEL: 'INTENCAO_ADD_VARIAVEL',
    INTENCAO_UPD_VARIAVEL: 'INTENCAO_UPD_VARIAVEL',
    INTENCAO_EXCLUIR_VARIAVEL: 'INTENCAO_EXCLUIR_VARIAVEL',
    VARIAVEL_VER_VARIAVEL: 'VARIAVEL_VER_VARIAVEL',
    INTENCAO_ADD_CARGO: 'INTENCAO_ADD_CARGO',
    INTENCAO_EXCLUIR_CARGO: 'INTENCAO_EXCLUIR_CARGO'

}

//
const Manutencao = ()=>{
    const dispatch = useDispatch();
    const drawer = useSelector(state=> state?.manutencao?.drawer);
    //
    let fnFecharDialogo = ()=> { };
    // Pegar a resolucao da tela para saber em qual estamos trabalhando
    const values = useTheme()?.breakpoints?.values;
    const isMobile = values?.sm > window.innerWidth;
    // const manutencao = useSelector(state=> state.manutencao);
    // Quando a pagina for carregada
    useEffect(()=>{
        // Busca dados relacionados aos usuarios
        dispatch(manutencaoUsuariosGetInit());
        // Busca dados relacionados as regioes
        dispatch(manutencaoRegioesGetInit());
        // Busca dados relacionados as variaveis
        dispatch(manutencaoVariaveisGetInit());
        // Busca dados relacionados aos cargos
        dispatch(manutencaoCargoGetInit());
    }, [ dispatch ]);
    // Abas e cabecalho
    const corpo = [
        <AbaUsuarios  />,
        <AbaRegioes  />,
        <AbaVariaveis />,
        <AbaCargos />,        
    ]
    const cabe = [      
        <Stack direction='row' alignItems='flex-end'>
            <PersonIcon />
            <Typography variant='body2'>
                Usuários
            </Typography>
        </Stack>,
        <Stack direction='row' alignItems='flex-end'>
            <PlaceIcon />
            <Typography variant='body2'>
                Regiões
            </Typography>
        </Stack>,
        <Stack direction='row' alignItems='flex-end'>
            <MediationIcon />
            <Typography variant='body2'>
                Variáveis
            </Typography>
        </Stack>,
        <Stack direction='row' alignItems='flex-end'>
        <EngineeringIcon />
            <Typography variant='body2'>
                Cargos
            </Typography>
        </Stack>,  
    ];
    // Verifica qual drawer foi ativado
    let corpoDrawer;

    if(drawer){
        const valor = drawer?.valor;
        fnFecharDialogo = ()=> dispatch(manutencaoSetDrawer(null));

        switch(drawer?.tipo){
            case VALORES_DRAWER.ALTERAR_SENHA:
                corpoDrawer =  <FormAlterarSenha id_usuario={valor} />
                break;
            case VALORES_DRAWER.ADD_USUARIO: // Para intencao de adicionar um usuario
                corpoDrawer = <FormAddusuario />
                break;
            case VALORES_DRAWER.INTENCAO_ADD_REGIAO_LOCALIDADE: // Para a intencao de adicionar uma localidade
                corpoDrawer = <FormAddUpdRegiaoLocalidade id_localidade={valor} />;
                break;
            case VALORES_DRAWER.INTENCAO_ADD_VARIAVEL: // Para intencao de adicionar uma variavel
                corpoDrawer = <FormAddUpdVariavel {...valor} />
                break;
            case VALORES_DRAWER.INTENCAO_UPD_VARIAVEL: // Para intencao de atualizar uma variavel
                corpoDrawer = <FormUpdValorVariavel {...valor} />
                break;
            case VALORES_DRAWER.INTENCAO_EXCLUIR_VARIAVEL: // Para a intencao de excluir uma variavel
                corpoDrawer = <ExcluirVariavel {...valor} />
                break;
            case VALORES_DRAWER.VARIAVEL_VER_VARIAVEL: // Para ver a variavel
                corpoDrawer = <VerVariavel {...valor} />
                break;
            case VALORES_DRAWER.INTENCAO_ADD_CARGO: // Intencao de adicionar um cargo
                corpoDrawer = (
                <FormAddUpdCargo 
                    {...valor} 
                />
                )
                break;
            case VALORES_DRAWER.INTENCAO_EXCLUIR_CARGO: // Intencao de excluir um cargo (se possivel)
                corpoDrawer = (
                    <FormExcluirCargo 
                        {...valor}
                    />
                )
                break;
            default:
                break;
        }
    }

    return (
        <Paper sx={{mt: 1, mb: {xs: 10, md: 0} }} elevation={0}>
            <ToastContainer position='bottom-center' autoClose={2500} />
            {isMobile ? (
            <Drawer 
                corpo={corpoDrawer}
                fecharDrawer={fnFecharDialogo}
            /> ) : (
                <Dialog
                    comoSlide 
                    corpo={corpoDrawer}  
                    fecharDialogo={fnFecharDialogo}
                
                />
            )}
            <Container disableGutters={isMobile} maxWidth='lg'>
                <Tab corpo={corpo} cabe={cabe} />
            </Container>

        </Paper>
    )
}
// Componente que representa a aba das variaveis
const AbaVariaveis =()=>{
    // Pegar a resolucao da tela para saber em qual estamos trabalhando
    const values = useTheme()?.breakpoints?.values;
    const isMobile = values?.sm > window.innerWidth;

    const [busca, setBusca] = useState('');
    const variaveis = useSelector(state=> state?.manutencao?.variaveis);
    const dispatch = useDispatch();
    // Se tiver uma busca faça o filtro
    let corpo;
    if(busca?.length > 0){
        corpo = variaveis.slice().filter(ele=> ( ele.nome.toLowerCase().search(busca.toLocaleLowerCase()) !== -1 ||  ele.descricao.toLowerCase().search(busca.toLocaleLowerCase()) !== -1) );
    } else {
        corpo = variaveis;
    }

    return (
        <Container maxWidth='lg'>
            <Typography variant='h6' align='center'>
                Variáveis que controlam recursos do sistema
            </Typography>
            <Typography component='p' variant='caption' align='center'>
                Esta pagina exibe as variaveis que são utilizadas no sistema para liberar/bloquear algum recurso que o administrador deseje. 
            </Typography>
            {isMobile && ( 
                <Fab 
                    color='primary' 
                    aria-label='add' 
                    onClick={()=>{
                        dispatch(manutencaoSetDrawer({tipo: VALORES_DRAWER.INTENCAO_ADD_VARIAVEL}));
                    }}
                    sx={{zIndex: 1000, position: 'fixed', right: 16, bottom: 72}}>
                        <AddIcon />
                </Fab> 
            )}
            <PainelAbaVariaveis 
                setBusca={setBusca}
            />            
            <List>
                {corpo?.map((ele)=>(
                    <ListItemVariaveis 
                        key={ele.id_parametro}
                        {...ele}
                    />
                ))}
            </List>
        </Container>
    )
}
// Componene que representa o painel superior para manutencao de variaveis
const PainelAbaVariaveis = ({ setBusca })=>{
    const dispatch = useDispatch();
    // Estado para recuperar valor
    const [valor, setValor] = useState('');
    const [pesquisa, setPesquisa] = useState(false);
    
    const [ , ] = useDebounce(
        ()=>{
            setBusca(valor);
            setPesquisa(false);
        },
        700,
        [valor]
    );
    //
    const fn = e=>{
        setValor(e.target.value);
        setPesquisa(true);
    }
    // Pegar a resolucao da tela para saber em qual estamos trabalhando
    const values = useTheme()?.breakpoints?.values;
    const isMobile = values?.sm > window.innerWidth;

    return (
        <Stack direction={{xs: 'column', md: 'row'}}>
            <TextField sx={{mx: {md: 1, xs: 0}, mt: 1}}
                type='search' fullWidth
                size='small' label='Pesquisar'
                onChange={fn}
                autoComplete='off'
                value={valor}
                placeholder='Procure por nome de variável ou descrição'
                InputProps={{
                    startAdornment: pesquisa ? <CircularProgress sx={{mr: 1}} size={20} /> : <SearchIcon color='primary' />
                }}
            />
            {!isMobile && (
                <Button title='Adicionar uma nova variável no sistema' sx={{mt: 1}} size='small' startIcon={<MediationIcon />} 
                    onClick={()=> dispatch(manutencaoSetDrawer({tipo: VALORES_DRAWER.INTENCAO_ADD_VARIAVEL })) } 
                    variant='contained'>
                    ADD
                </Button>
            )}

        </Stack>
    )
}
// Comopnente que representa um item da lista de variaveis
const ListItemVariaveis = memo(({ id_parametro, nome, descricao, valor, opcoes })=>{
    const dispatch = useDispatch();

    // Verifica se e mobile ou nao
    const isMobile = useTheme().breakpoints.values.sm > window.innerWidth;
    const isDark = useTheme().palette.mode === 'dark';

    const [anchorEl, setAnchorEl] = useState('');
    // Esta funcao vai definir que o menu deve ser exibido
    const fnManipularMenu = (evt)=>{
        setAnchorEl(evt.currentTarget);
    }
    // Funcao para fechar o menu
    const fnFecharMenu = ()=> setAnchorEl(null);

    const itensMenu = [
        {titulo: 'Para alterar o valor da variavel', corTexto: '', texto: 'ALT. VALOR', onClick: ()=>{
            fnFecharMenu();
            dispatch(
                manutencaoSetDrawer({
                    tipo: VALORES_DRAWER.INTENCAO_UPD_VARIAVEL,
                    valor: {
                        nome,
                        descricao,
                        id_parametro, 
                        valor,
                        opcoes
                    }
                })
            );
        }, icone: <EditIcon /> },
        {titulo: 'Para alterar a variavel por completo', corTexto: '', texto: 'ALT. VARIÁVEL', onClick: ()=>{
            dispatch(manutencaoSetDrawer({
                tipo: VALORES_DRAWER.INTENCAO_ADD_VARIAVEL,
                valor: {
                    id_parametro, nome, descricao, 
                    valor, 
                    opcoesAntigas: opcoes
                }
            }))
            fnFecharMenu();
        }, icone: <EditIcon /> },
        {titulo: 'Para exclusão de variável. Operação irreversivel', corTexto: '', texto: 'EXCLUIR VARIÁVEL', onClick: ()=>{
            fnFecharMenu();
            dispatch(manutencaoSetDrawer({
                tipo: VALORES_DRAWER.INTENCAO_EXCLUIR_VARIAVEL,
                valor: {
                    id_parametro, nome
                }
            }))
        }, icone: <DeleteIcon /> },
    ]

    return (
        <ListItem onClick={()=>{
            dispatch(manutencaoSetDrawer({
                tipo: VALORES_DRAWER.VARIAVEL_VER_VARIAVEL,
                valor: {
                    id_parametro, nome, valor, opcoes, descricao
                }
            }))
        }} divider>
            <ListItemText
                primary={nome}
                secondary={
                    <Stack>
                        <Typography variant='body2'>
                            {descricao}
                        </Typography>
                        
                        <Typography color='primary' variant='caption'>
                           VALOR ATUAL: 
                           <Chip sx={{ml: 1}}
                            color='primary'
                            size='small'
                            label={valor}
                            />
                        </Typography>
                    </Stack>
                }
            />
                        <ListItemSecondaryAction sx={{display: 'flex', flexDirection: 'column'}}>
                {isMobile ? (
                    <IconButton color={isDark ? 'secondary' : 'primary'} onClick={fnManipularMenu}>
                        <MoreVertIcon />
                    </IconButton>
                    ) : (
                    <Button color={isDark ? 'secondary' : 'primary'} onClick={fnManipularMenu} title='Clique aqui para ver as opções disponíveis' startIcon={<MoreVertIcon />} variant='text' size='small'>
                        OPÇÕES
                    </Button>
                    )}
                    <Menu anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={fnFecharMenu}
                        MenuListProps={{ 'aria-labelledby': 'basic-button' }}>
                        {itensMenu.map((ele, idx)=>(
                        <MenuItem title={ele.titulo} key={idx} divider={idx < 2} onClick={ele.onClick}>
                                {ele.icone}
                            <Typography color={ele?.corTexto} sx={{ml: 1}} variant='body2'>
                                {ele.texto}
                            </Typography>
                        </MenuItem>

                        ))}
                    </Menu>            
            </ListItemSecondaryAction> 
        </ListItem>
    )

});
// Componente que cria formulario para adicao de variaveis
const FormAddUpdVariavel = ({ id_parametro, nome, descricao, valor, opcoesAntigas  })=>{
    const dispatch = useDispatch();
    const [opcoes, setOpcoes] = useState(opcoesAntigas || []);
    // Pegar a resolucao da tela para saber em qual estamos trabalhando
    const values = useTheme()?.breakpoints?.values;
    const isMobile = values?.sm > window.innerWidth;

    const aguardar = useSelector(state=> state.aguardar);
    
    //
    let valoresDefault = {};
    if(id_parametro){
        valoresDefault = {
            nome,
            descricao,
            valor,
        }
    }
    
    const { formState: { errors }, handleSubmit, control } = useForm({
        defaultValues: valoresDefault
    });
    //
    const fn = val=>{
        const { nome, descricao, valor} = val;
        // Verifica se o valor a ser enviado existe nas opcoes registradas
        if(!opcoes.includes(valor)){
            toast.dark('O valor inicial informado não confere com nenhuma alternativa cadastrada', {
                type: 'error'
            });
            return false;
        }
        // Veja se existe ao menos uma opcao
        if(opcoes?.length < 1){
            toast.dark('Nenhuma opção foi informada. Necessário haver ao menos uma opção', {
                type: 'error'
            });
            return false;
        }
        let obj = {
            nome,
            descricao,
            valor,
            opcoes
        };

        if(id_parametro){
            obj['id_parametro'] = id_parametro;
        }
        // Passou tudo vamos prosseguir
        dispatch(
            manutencaoVariaveisAddUpdVariavel(obj, Boolean(id_parametro))
        );

    }
    // Funcao de callback para incluir uma opcao
    const fnAddOpcao = (e)=>{
        // Se o valor da tecla for igual a 13
        if(e.keyCode === 13){
            const valor = e.target.value;
            setOpcoes(state=>{
                if(!state.includes(valor)){
                    state.push(valor);
                }
                return [...state];
            });
            // Limpa o campo de insercao
            e.target.value = "";
        }
        
    }

    return (
        <Container maxWidth='md' sx={{p: 1}}>
        <Stack spacing={2}>
            <Typography variant='h6' align='center'>
               {id_parametro ? 'Atualizar' : 'Adicionar uma'} variável
            </Typography>
            <Typography variant='body2' align='center' component='p'>
                Este formulario e usado para {id_parametro ? 'atualizar uma' : 'adicionar uma nova'} variavel ao sistema. Defina nome, descrição valor e inclua possiveis opções.
            </Typography>
            <Controller 
                control={control}
                name='nome'
                rules={{required: true}}
                render={({ field })=>(
                    <TextField fullWidth {...field}
                        label='Nome' size='small'
                        autoComplete='off'
                        InputLabelProps={{
                            shrink: true
                        }}
                        
                        placeholder='Digite o nome da variável'
                        error={!!errors.nome}
                        helperText={!!errors.nome && '* Campo obrigatório'}
                    />
                )}
            />
            <Controller 
                control={control}
                name='descricao'
                rules={{required: true}}
                render={({ field })=>(
                    <TextField fullWidth {...field}
                        label='Descricao' size='small' type='textarea' minRows={2}
                        multiline
                        InputLabelProps={{ shrink: true }}
                        placeholder='Digite uma descrição para a variável'
                        error={!!errors.nome}
                        helperText={!!errors.nome && '* Campo obrigatório'}
                    />
                )}
            />
            <Controller 
                control={control}
                name='valor'
                rules={{required: true}}
                render={({ field })=>(
                    <TextField fullWidth {...field}
                        label='Valor inicial' size='small'
                        InputLabelProps={{
                            shrink: true
                        }}
                        placeholder='Digite um valor inicial para a variável'
                        error={!!errors.nome}
                        helperText={!!errors.nome && '* Campo obrigatório'}
                    />
                )}
            />

            <TextField fullWidth
                autoComplete='off'
                label='Opção' size='small'
                InputLabelProps={{
                    shrink: true
                }}
                onKeyUp={fnAddOpcao}
                placeholder='Digite a opção e pressione Enter'
                
            />
            {opcoes?.length > 0 && (
            <Paper sx={{p: 1}} elevation={3}>
            <Typography color='secondary' variant='subtitle1' align='center'>
                Opções definidas que vão compor as alternativas da variável
            </Typography>
            <Stack direction='row' flexWrap='wrap'>
                {opcoes.map((ele,idx)=>(
                    <Chip key={idx} sx={{mx: .3}}
                        label={ele}
                        onDelete={()=>{
                            setOpcoes(state=> state.filter(eleIn=> String(eleIn) !== String(ele) ) );
                        }}
                        deleteIcon={<DeleteIcon title='Clique aqui para remover a opção escolhida' />}
                        
                    />
                ))}
            </Stack>
            </Paper>
            )}
            
                        
            <Stack direction='row' justifyContent={{md: 'center', xs: 'stretch'}}>
                <Button fullWidth={isMobile} variant='contained' disabled={aguardar} onClick={handleSubmit(fn)} startIcon={aguardar ? <CircularProgress size={20} /> : <SaveIcon /> }>
                    SALVAR
                </Button>
            </Stack>
        </Stack>
        </Container>
    )

}
// Componente para alterar o valor da variavel
const FormUpdValorVariavel = ({ id_parametro, descricao, nome, valor, opcoes })=>{
    const dispatch = useDispatch();
    // Pegar a resolucao da tela para saber em qual estamos trabalhando
    const values = useTheme()?.breakpoints?.values;
    const isMobile = values?.sm > window.innerWidth;
    const aguardar = useSelector(state=> state.aguardar);

    const { handleSubmit, formState: { errors }, control } = useForm({
        resolver: yupResolver(schemaUpdVariavel)
    });
    // Funcao para manipular o formulario validado
    const fn = val=>{
        const { valor } = val;
        //
        dispatch(manutencaoVariaveisUpdValor({
            id_parametro,
            valor: valor.value
        }));
    }


    return (
        <Container maxWidth='md' sx={{p: 1, minHeight: '40vh', overflowY: 'auto'}}>
        <Stack spacing={2}>
            <Typography variant='h6' align='center'>
                Alterar valor da variável &nbsp;&nbsp;
                <Typography component='span' variant='subtitle1' color='secondary' align='center'>
                    {nome}
                </Typography>
                
            </Typography>
            <Typography component='p' variant='body2' align='center'>
                {descricao}                    
            </Typography>
            
            <Controller 
                control={control}
                defaultValue={formatarParaSelect([valor])[0]}
                name='valor'
                rules={{required: true}}
                render={({ field })=>(
                    <Stack>
                      <Typography variant='h6' align='center' fontWeight='bold'>
                          Opções
                      </Typography>
                      <Select {...field} options={formatarParaSelect(opcoes)} 
                        styles={selectStyles} isDisabled={aguardar}
                      />
                      {(!!errors.valor && (
                          <Typography variant='caption' color='error' align='center'>
                              {errors.valor}                            
                          </Typography>
                      ))}

                    </Stack>
                )}
            />            
                        
            <Stack direction='row' justifyContent={{md: 'center', xs: 'stretch'}}>
                <Button fullWidth={isMobile} variant='contained' disabled={aguardar} onClick={handleSubmit(fn)} startIcon={aguardar ? <CircularProgress size={20} /> : <SaveIcon /> }>
                    SALVAR
                </Button>
            </Stack>
        </Stack>
        </Container>
    )

}
// Componente para determinar se deve ou não excluir variavel
const ExcluirVariavel = ({ nome, id_parametro })=>{
    const dispatch = useDispatch();
    // Funcao de callback caso seja confirmada a exclusão
    const fnExcluir = ()=>{
        dispatch(manutencaoVariaveisDelVariavel({
            id_parametro
        }))
    }
    // Funcao de callback para cancelar a exclusao
    const fnCancelar = ()=>{
        dispatch(manutencaoSetDrawer(null));
    }

    return (
        <Container sx={{p: 1}} maxWidth='md'>
        <Stack spacing={2}>
            <Stack>
            <Typography variant='h6' align='center'>
                EXCLUSÃO DE VARIÁVEL
            </Typography>
            <Divider />
            </Stack>
            <Typography variant='body1' align='center' component='p'>
                Você tem certeza que deseja excluir a variável &nbsp;&nbsp;
                <Typography component='span' color='secondary' variant='body1'>
                    {nome}
                </Typography>
            </Typography>
            <Stack direction='row-reverse'>
                <Button onClick={fnExcluir} startIcon={<DeleteIcon />} sx={{ml: 1}} variant='contained'>SIM</Button>
                <Button onClick={fnCancelar} variant='text'>NÃO</Button>
            </Stack>
        </Stack>
        </Container>
    )
}
// Componente que exibe a variavel por completo (todas as informacoes)
const VerVariavel = ({ id_parametro, nome, descricao, valor, opcoes })=>{

    return (
        <Container maxWidth='md' sx={{p: 1}}>
        <Stack spacing={2}>
            <Typography variant='h6' align='center'>
                Detalhes da variavel
            </Typography>
            <Typography color='secondary' align='center' variant='body2'>
                {nome}
            </Typography>
            <Typography variant='body2'>
                {descricao}
            </Typography>
            <Typography variant='body2'>
                {valor}
            </Typography>
            
            {opcoes?.length > 0 && (
            <Paper sx={{p: 1}} elevation={0}>
            <Typography color='secondary' variant='subtitle1' align='center'>
                Opções que podem ser utilizadas
            </Typography>
            <Stack direction='row' flexWrap='wrap'>
                {opcoes.map((ele,idx)=>(
                    <Chip key={idx} sx={{mx: .3}}
                        label={ele} 
                        color={ele === valor ? 'primary' : 'default'}                       
                    />
                ))}
            </Stack>
            </Paper>
            )}
            
                        
            
        </Stack>
        </Container>

    )

}

// Componente para criar um painel superior para possiveis filtros
const PainelAbaUsuarios = ({ somenteAdmin, setSomenteAdmin, setSomenteBloqueado, somenteBloqueado, setBusca })=>{
    const dispatch = useDispatch();
    // Estado para recuperar valor
    const [valor, setValor] = useState('');
    const [pesquisa, setPesquisa] = useState(false);
    
    const [ , ] = useDebounce(
        ()=>{
            setBusca(valor);
            setPesquisa(false);
        },
        700,
        [valor]
    );
    //
    const fn = e=>{
        setValor(e.target.value);
        setPesquisa(true);
    }
    // Pegar a resolucao da tela para saber em qual estamos trabalhando
    const values = useTheme()?.breakpoints?.values;
    const isMobile = values?.sm > window.innerWidth;

    return (
        <Stack direction={{xs: 'column', md: 'row'}}>
            <TextField sx={{mx: {md: 1, xs: 0}, mt: 1}}
                type='search' fullWidth
                size='small' label='Pesquisar'
                autoComplete='off'
                onChange={fn}
                value={valor}
                placeholder='Procure por e-mail ou nome'
                InputProps={{
                    startAdornment: pesquisa ? <CircularProgress sx={{mr: 1}} size={20} /> : <SearchIcon color='primary' />
                }}
            />
            {!isMobile && (
                <Button title='Adicionar novo Usuario ao sistema' sx={{mt: 1}} size='small' startIcon={<PersonAddIcon />} onClick={()=>{
                    dispatch(manutencaoSetDrawer({ tipo: VALORES_DRAWER.ADD_USUARIO }));
                }} variant='contained'>
                    ADD
                </Button>
            )}
            <Stack direction='row' justifyContent={{md: 'flex-start', xs: 'space-between'}}>
                <FormControlLabel sx={{mx: 1}} title='Exibe somente usuários marcados como admin'
                        control={ 
                            <Switch checked={somenteAdmin} 
                                onChange={()=> setSomenteAdmin(state=> !state)} 
                            />
                        } 
                        label='Admin'
                    />
                <FormControlLabel sx={{mx: 1}} title='Exibe somente os usuários bloqueados'
                        control={ 
                            <Switch checked={somenteBloqueado} 
                                onChange={()=> setSomenteBloqueado(state=> !state)} 
                            />
                        } 
                        label='Bloqueado'
                    />
            </Stack>
        </Stack>
    )
}
// Componente que representa a aba dos usuarios
const AbaUsuarios = ()=>{
    const dispatch = useDispatch();
    // Caso o usuario use o recurso de busca, o valor será armazenado auqi.
    const [busca, setBusca] = useState('');
    // Para buscar usuarios que sao somente admin
    const [somenteAdmin, setSomenteAdmin] = useState(false);
    const [somenteBloqueado, setSomenteBloqueado] = useState(false);

    const usuario = useSelector(state=> state.manutencao?.usuarios);
    // Faça um filtro para saber quantos itens são exibidos
    let corpo = usuario?.filter(ele=> (ele.nome.toLowerCase().search(busca.toLowerCase()) !== -1) || (ele.email.toLowerCase().search(busca.toLowerCase()) !== -1) );
    
    // Se somente Admin estiver ativo faça outro filtro sobre  o corpo para encontra-los
    if(somenteAdmin) corpo = corpo.filter(ele=> ele.admin === 'S');
    // Se somente bloqueado estiver ativo vamos filtrar sobre este campo
    if(somenteBloqueado) corpo = corpo.filter(ele=> ele.bloqueado === 'S');  
      
    // Pegar a resolucao da tela para saber em qual estamos trabalhando
    const values = useTheme()?.breakpoints?.values;
    const isMobile = values?.sm > window.innerWidth;

    return (
        <Container disableGutters={isMobile} sx={{mt: 1}} maxWidth='lg'>
            {isMobile && ( 
                <Fab 
                    color='primary' 
                    aria-label='add' 
                    onClick={()=>{
                        dispatch(manutencaoSetDrawer({tipo: VALORES_DRAWER.ADD_USUARIO}));
                    }}
                    sx={{zIndex: 1000, position: 'fixed', right: 16, bottom: 72}}>
                        <PersonAddIcon />
                </Fab> 
            )}
            <PainelAbaUsuarios 
                setBusca={setBusca}
                setSomenteAdmin={setSomenteAdmin}
                somenteAdmin={somenteAdmin}
                setSomenteBloqueado={setSomenteBloqueado}
                somenteBloqueado={somenteBloqueado}
            />
            {usuario ? (somenteAdmin || somenteBloqueado || busca )  ? (
                <List>
                    {corpo?.map((ele,idx)=>(
                        <ListaItemUsuario key={ele.id_usuario}
                            {...ele}
                            //setAlterarSenha={setAlterarSenha}
                        />
                    ))}
                </List>

            ) : <Paginacao
                corpo={corpo}
                totalPorPagina={20}
                componentePai={(filho) => <List>{filho}</List> }
                component={(props)=> (
                    <ListaItemUsuario {...props} 
                        key={props.id_usuario}                        
                    />
                    )
                }
            /> : null}
            
        </Container>
    )
}
// Componente para listar o usuario
const ListaItemUsuario = memo( ({ id_usuario, admin, ultimo_acesso, bloqueado, nome, email, avatar })=>{
    const isAdmin = admin === 'S';
    const isBloqueado = bloqueado === 'S';

    const dispatch = useDispatch();

    // Verifica se e mobile ou nao
    const isMobile = useTheme().breakpoints.values.sm > window.innerWidth;
    const isDark = useTheme().palette.mode === 'dark';

    const [anchorEl, setAnchorEl] = useState('');
    // Esta funcao vai definir que o menu deve ser exibido
    const fnManipularMenu = (evt)=>{
        setAnchorEl(evt.currentTarget);
    }
    // Funcao para fechar o menu
    const fnFecharMenu = ()=> setAnchorEl(null);
                
    // Funcao de callback para lidar com alteração de um usuario
    const fnLiberarBloquear = ()=>{
        if(!window.confirm(`Deseja ${isBloqueado ? 'desbloquear': 'bloquear'} o usuário ?`)) return false;
        dispatch(
            manutencaoUsuariosGestaoUsuario({
                id_usuario,
                admin: isAdmin ? 'S' : 'N',
                bloqueado: isBloqueado ? 'N' : 'S'
            })
        )
        fnFecharMenu();
    }
    // Funcao para lidar com a definicao de um usuario a ser admin ou nao
    const fnTornarAdmin = ()=>{
        if(!window.confirm(`Deseja ${!isAdmin ? 'conceder poder': 'retirar poder'} administrativo ?`)) return false;
        dispatch(
            manutencaoUsuariosGestaoUsuario({
                id_usuario,
                admin: isAdmin ? 'N' : 'S',
                bloqueado: isBloqueado ? 'S' : 'N'
            })
        )
        fnFecharMenu();

    }
    // Funcao para excluir um usuario
    const fnExcluir  = ()=>{
        dispatch(
            manutencaoUsuariosExcluirUsuario({ id_usuario })
        )
        fnFecharMenu();
    }
    // Opcoes para interagir com o usuario
    const itensMenu = [
        {titulo: 'Liberar ou bloquear o usuário para usar o sistema', icone: <BlockIcon />, onClick: fnLiberarBloquear, texto: `${isBloqueado ? 'Liberar' : 'Bloquear'}`, textoMobile: `${ isBloqueado ? 'Lib' : 'Bloq'}`  },
        {titulo: 'Tornar-lo admin ou retirar este direito', icone: <AdminPanelSettingsIcon />, onClick: fnTornarAdmin, texto: `${isAdmin ? 'Desfazer' : 'Torna-lo'}`, textoMobile: `${isAdmin ? 'Desf' : 'Torn'}` },
        {titulo: 'Alterar a senha do usuario', icone: <VpnKeyIcon />, onClick: ()=> { 
            fnFecharMenu();
            //setAlterarSenha(id_usuario); 
            dispatch(manutencaoSetDrawer({tipo: VALORES_DRAWER.ALTERAR_SENHA , valor: id_usuario}));
        }, texto: 'Senha', textoMobile: 'Senha' },
        {titulo: 'Excluir o usuário informado', icone: <DeleteIcon />, onClick: fnExcluir, texto: 'Excluir', textoMobile: 'REM' },
    ]
        
    return (
        <ListItem disablePadding divider>
            <ListItemAvatar>
                <Avatar alt={nome} src={avatar} />
            </ListItemAvatar>
            <ListItemText
                primaryTypographyProps={{color: 'secondary'}}
                primary={nome}
                secondary={
                    <>
                      <Typography variant='caption'>{email}</Typography>
                      <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                          {isAdmin && (
                              <Box sx={{display: 'flex', alignItems: 'center'}}>
                                <AdminPanelSettingsIcon color='primary' />
                                <Typography color='primary' variant='caption'>Admin</Typography>
                            </Box>
                          )}
                          {isBloqueado && (
                              <Box sx={{display: 'flex', alignItems: 'center'}}>
                                <BlockIcon color='primary' />&nbsp;
                                <Typography color='primary' variant='caption'>Bloqueado</Typography>
                              </Box>
                          )}
                      </Box>
                      <Typography variant='caption' >
                          Ultimo Acesso: {format(parseISO(ultimo_acesso), 'dd/MM/yyyy HH:mm')} 
                      </Typography>                      
                    </>
                } 
            /> 
            <ListItemSecondaryAction sx={{display: 'flex', flexDirection: 'column'}}>
                {isMobile ? (
                    <IconButton color={isDark ? 'secondary' : 'primary'} onClick={fnManipularMenu}>
                        <MoreVertIcon />
                    </IconButton>
                    ) : (
                    <Button color={isDark ? 'secondary' : 'primary'} onClick={fnManipularMenu} title='Clique aqui para ver as opções disponíveis' startIcon={<MoreVertIcon />} variant='text' size='small'>
                        VER
                    </Button>
                    )}
                    <Menu anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={fnFecharMenu}
                        MenuListProps={{ 'aria-labelledby': 'basic-button' }}>
                        {itensMenu.map((ele, idx)=>(
                        <MenuItem title={ele.titulo} key={idx} divider={idx < 3} onClick={ele.onClick}>
                                {ele.icone}
                            <Typography color={ele?.corTexto} sx={{ml: 1}} variant='body2'>
                                {ele.texto}
                            </Typography>
                        </MenuItem>

                        ))}
                    </Menu>            
            </ListItemSecondaryAction> 
        </ListItem>
    )
});

// Componente que exibir um formulario para alteração de senha
const FormAlterarSenha = ({ id_usuario })=>{
    //
    const nomeUsuario = useSelector(state=> state.manutencao.usuarios).filter(ele=> String(ele.id_usuario) === String(id_usuario))[0].nome;

    const dispatch = useDispatch();
    const aguardar = useSelector(state=> state.aguardar);

    //
    const { control, formState: { errors }, handleSubmit } = useForm({
        resolver: yupResolver(schema),
    });
    // Funcao para lidar com a atualizacao
    const fn = val=>{
        const { senha, confirmarSenha } = val;
        // verifica se a senha um e igual a senha 2
        if (senha !== confirmarSenha) {
            toast.dark('As senhas devem ser iguais', {
                position: 'bottom-center',
                type: 'error',
                style: {
                    backgroundColor: '#141414',
                    color: 'white'
                },
            });
            return false;
        }
        // Senhas validadas como iguais, enviar para atualizacao
        dispatch(
            manutencaoUsuariosAtualizarSenha({
                id_usuario,
                senha,
            })
        )
    }


    return (
        <Container sx={{py: 1}} maxWidth='md'>
            <Typography color='primary' variant='h6' align='center'>
                Usuário {nomeUsuario}            
            </Typography>
            <Typography sx={{opacity: .8, mb: 1}} component='p' variant='caption' align='center'>
                Para redefinir a senha do usuário digite ela no campo senha e repita o mesmo valor abaixo (mínimo 6 caracteres).
            </Typography>
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Controller 
                    control={control}
                    name='senha'
                    rules={{required: true}}
                    defaultValue=''
                    render={({ field })=>(
                        <TextField label='Senha' fullWidth 
                          type="password" {...field} size='small'
                          helperText={!!errors.senha && 'Minimo de 6 caracteres'}
                          error={!!errors.senha}
                            InputProps={{
                                autoComplete: false,
                                startAdornment: <VpnKeyIcon />
                            }} 
                            InputLabelProps={{ shrink: true }}
                            placeholder='Digite a nova senha'
                        />
                    )}
                />                
            </Grid>
            <Grid item xs={12}>
                <Controller 
                    control={control}
                    name='confirmarSenha'
                    rules={{required: true}}
                    defaultValue=''
                    render={({ field })=>(
                    <TextField label='Confirmar senha' fullWidth 
                        type="password" {...field} size='small'
                        helperText={!!errors.confirmarSenha && 'Minimo de 6 caracteres'}
                        error={!!errors.confirmarSenha}
                        InputProps={{
                            autoComplete: false,
                            startAdornment: <VpnKeyIcon />
                        }} 
                        InputLabelProps={{ shrink: true }}
                        placeholder='Confirme a nova senha'
                    />
                    )}
                />
            </Grid>
            <Hidden mdDown>
                <Grid item xs={4} />
            </Hidden>
            <Grid item xs={12} md={4}>
                <Button 
                    onClick={handleSubmit(fn)} 
                    disabled={aguardar}
                    startIcon={aguardar ? <CircularProgress size={20} /> : <SaveIcon />} 
                    variant='contained' fullWidth>
                        Salvar
                </Button>
            </Grid>
        </Grid>
        </Container>
    )
}
// Componente para insercao de novo usuario
const FormAddusuario = ()=>{
    //
    const dispatch = useDispatch();
    const aguardar = useSelector(state=> state.aguardar);

    //
    const { control, formState: { errors }, handleSubmit } = useForm({
        resolver: yupResolver(schema2),
    });
    // Funcao para lidar com a atualizacao
    const fn = val=>{
        const { email, nome, senha } = val;
        // Faça o envio para cadastro do novo usuario
        dispatch(
            manutencaoUsuariosAdicionarUsuario({
                email, nome, senha
            })
        )
    }


    return (
        <Container sx={{py: 1}} maxWidth='sm'>
            <Typography color='primary' variant='h6' align='center'>
                Cadastro de usuário
            </Typography>
            <Typography sx={{opacity: .8, mb: 1}} component='p' variant='caption' align='center'>
                Defina o seu nome completo, email e senha que será utilizado para ele acessar a interface.
            </Typography>

        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Controller 
                    control={control}
                    name='nome'
                    rules={{required: true}}
                    defaultValue=''
                    render={({ field })=>(
                        <TextField label='Nome' fullWidth 
                          type="text" {...field}
                          helperText={!!errors.nome && 'Minimo de 6 caracteres'}
                          error={!!errors.nome}
                            InputProps={{
                                autoComplete: false,
                                startAdornment: <PersonIcon color='primary' />
                            }} 
                            InputLabelProps={{ shrink: true }}
                            placeholder='Digite o nome'
                        />
                    )}
                />                
            </Grid>
            <Grid item xs={12}>
                <Controller 
                    control={control}
                    name='email'
                    rules={{required: true}}
                    defaultValue=''
                    render={({ field })=>(
                        <TextField label='Email' fullWidth 
                          type="email" {...field}
                          helperText={!!errors.email && 'Ex: email@exemplo.com'}
                          error={!!errors.email}
                            InputProps={{
                                autoComplete: false,
                                startAdornment: <EmailIcon color='primary' />
                            }} 
                            InputLabelProps={{ shrink: true }}
                            placeholder='Digite o email'
                        />
                    )}
                />                
            </Grid>

            <Grid item xs={12}>
                <Controller 
                    control={control}
                    name='senha'
                    rules={{required: true}}
                    defaultValue=''
                    render={({ field })=>(
                        <TextField label='Senha' fullWidth 
                          type="password" {...field}
                          helperText={!!errors.senha && 'Minimo de 6 caracteres'}
                          error={!!errors.senha}
                            InputProps={{
                                autoComplete: false,
                                startAdornment: <VpnKeyIcon color='primary' />
                            }} 
                            InputLabelProps={{ shrink: true }}
                            placeholder='Digite a nova senha'
                        />
                    )}
                />                
            </Grid>
            <Hidden mdDown>
                <Grid item xs={4} />
            </Hidden>
            <Grid item xs={12} md={4}>
                <Button 
                    onClick={handleSubmit(fn)} 
                    disabled={aguardar}
                    startIcon={aguardar ? <CircularProgress size={20} /> : <SaveIcon />} 
                    variant='contained' fullWidth>
                        Salvar
                </Button>
            </Grid>
        </Grid>
        </Container>
    )
}
// Componente que exibe a aba das regiões
const AbaRegioes = ()=>{
    const dispatch = useDispatch();
    const dados = useSelector(state=> state?.manutencao?.regioes?.dados);
    const [busca, setBusca ] = useState('');
    
    // Filtra os dados para buscar por localidade ou regiao
    let corpo = dados ? dados?.filter(ele=> (ele.regiao.toLowerCase().search(busca.toLowerCase()) !== -1) || (ele.localidade.toLowerCase().search(busca.toLowerCase()) !== -1) ) : [];
    // Pegar a resolucao da tela para saber em qual estamos trabalhando
    const values = useTheme()?.breakpoints?.values;
    const isMobile = values?.sm > window.innerWidth;

    return (
        <Container maxWidth='lg'>
            {isMobile && ( 
                <Fab 
                    color='primary' 
                    aria-label='add' 
                    onClick={()=> dispatch(manutencaoSetDrawer({ tipo: VALORES_DRAWER.INTENCAO_ADD_REGIAO_LOCALIDADE }))}
                    sx={{zIndex: 1000, position: 'fixed', right: 16, bottom: 72}}>
                        <AddLocationIcon />
                </Fab> 
            )}
            <Typography variant='h6' align='center'>
                Regiões e localidades
            </Typography>
            <Typography variant='body2' align='center'>
                As regiões são os locais onde o candidato opta por trabalhar (onde ele tem disponibilidade). A manutenção e cadastro fica a cargo do administrador do sistema.
            </Typography>
            <PainelAbaRegioes 
                setBusca={setBusca}
                
            />
            <Divider sx={{my: 2}} />
            {corpo ? (busca) ? (
                <List>
                    {corpo?.map(ele=>(
                        <ListaItemRegioes
                            key={ele.id_localidade} {...ele}
                        />
                    ))}
                </List>

            ) : (
            <Paginacao
                totalPorPagina={10}
                corpo={corpo}
                componentePai={(filho)=> <List>{filho}</List>}
                component={(props)=> <ListaItemRegioes {...props} />}
            />
            ): null}
        </Container>
    )
}
// Componente para o painel de abas das regioes
const PainelAbaRegioes = ({ setBusca })=>{
    const dispatch = useDispatch();
    // Estado para recuperar valor
    const [valor, setValor] = useState('');
    const [pesquisa, setPesquisa] = useState(false);
    
    const [ , ] = useDebounce(
        ()=>{
            setBusca(valor);
            setPesquisa(false);
        },
        700,
        [valor]
    );
    //
    const fn = e=>{
        setValor(e.target.value);
        setPesquisa(true);
    }
    // Pegar a resolucao da tela para saber em qual estamos trabalhando
    const values = useTheme()?.breakpoints?.values;
    const isMobile = values?.sm > window.innerWidth;

    return (
        <Stack sx={{mt: 1}} direction='row' alignItems='baseline'>
            <TextField sx={{mx: {md: 1, xs: 0}, mt: 1}}
                type='search' fullWidth
                size='small' label='Pesquisar'
                autoComplete='off'
                onChange={fn}
                value={valor}
                placeholder='Procure por região ou localidade'
                InputProps={{
                    startAdornment: pesquisa ? <CircularProgress sx={{mr: 1}} size={20} /> : <SearchIcon color='primary' />
                }}
            />
             {!isMobile && (
                 <Button sx={{ml: 1}} onClick={()=> dispatch(manutencaoSetDrawer({ tipo: VALORES_DRAWER.INTENCAO_ADD_REGIAO_LOCALIDADE })) } 
                    title='Adicionar localização' size='small' startIcon={<AddLocationIcon />} variant='contained'>
                    ADD
                </Button>
            )}
        </Stack>
    )

    
}
// Componente para exibir o item das regioes
const ListaItemRegioes = memo(({ regiao, localidade, id_localidade, utilizado })=>{
    const dispatch = useDispatch();

    // Verifica se e mobile ou nao
    const isMobile = useTheme().breakpoints.values.sm > window.innerWidth;
    const isDark = useTheme().palette.mode === 'dark';

    const [anchorEl, setAnchorEl] = useState('');
    // Esta funcao vai definir que o menu deve ser exibido
    const fnManipularMenu = (evt)=>{
        setAnchorEl(evt.currentTarget);
    }
    // Funcao para fechar o menu
    const fnFecharMenu = ()=> setAnchorEl(null);
    //
    const itensMenu = [
        {texto: 'EDITAR', corTexto: null, icone: <EditLocationAltIcon />, titulo: 'Clique aqui se deseja editar este registro', onClick: ()=>{ 
            fnFecharMenu();
            // Opcao para editar um registro
            dispatch(manutencaoSetDrawer({tipo: VALORES_DRAWER.INTENCAO_ADD_REGIAO_LOCALIDADE, valor: id_localidade}));
            
        }},
        {texto: 'EXCLUIR', corTexto: null, icone: <DeleteIcon />, titulo: 'Clique aqui se deseja excluir esta localidade', onClick: ()=>{
            dispatch(manutencaoRegioesDelRegiaoLocalidade({id_localidade}));
            fnFecharMenu();
         }},
    ]


    return (
        <ListItem disableGutters divider>
            <ListItemIcon>
                <PlaceIcon />
            </ListItemIcon>
            <ListItemText
                primaryTypographyProps={{color: isDark ? 'secondary' : 'primary'}}
                primary={regiao}
                secondary={localidade}
            />
            <ListItemSecondaryAction sx={{display: 'flex', flexDirection: 'column'}} >
                {isMobile ? (
                <IconButton color={isDark ? 'secondary' : 'primary'} onClick={fnManipularMenu}>
                    <MoreVertIcon />
                </IconButton>
                ) : (
                <Button color={isDark ? 'secondary' : 'primary'} onClick={fnManipularMenu} title='Clique aqui para ver as opções disponíveis' startIcon={<MoreVertIcon />} variant='text' size='small'>
                    VER
                </Button>
                )}
                <Menu anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={fnFecharMenu}
                    MenuListProps={{ 'aria-labelledby': 'basic-button' }}>
                    {itensMenu.map((ele, idx)=>(
                    <MenuItem disabled={idx === 1 && utilizado} key={idx} divider={idx === 0} onClick={ele.onClick}>
                            {ele.icone}
                        <Typography color={ele?.corTexto} sx={{ml: 1}} variant='body2'>
                            {ele.texto}
                        </Typography>
                    </MenuItem>

                    ))}
                </Menu>
            </ListItemSecondaryAction>
        </ListItem>
    )
})
// Componente para insercao de uma nova região/localidade
const FormAddUpdRegiaoLocalidade = ({ id_localidade })=>{
    //
    const dispatch = useDispatch();
    //
    const regioes = useSelector(state=> state.manutencao?.regioes?.regioes);
    const dados = useSelector(state=> state.manutencao?.regioes?.dados);
    const aguardar = useSelector(state=> state.aguardar);

    let valorPadrao;

    if(id_localidade) {
        // Necessario fazer o stringify/parse pois a referencia a regiao estava sendo trocada no objeto original
        valorPadrao = JSON.parse( JSON.stringify( dados.filter(ele=> String(ele.id_localidade) === String(id_localidade))) )[0];
        valorPadrao.regiao = formatarParaSelect([valorPadrao.regiao])[0];
    }
    
    const { handleSubmit, formState: { errors }, control } = useForm({
        resolver: yupResolver(schemaAddLocal),
        defaultValues: valorPadrao
    });
    //
    const fn = val=>{
        const { localidade } = val;
        const regiao = val.regiao.value;
        const obj = {
            localidade,
            regiao
        }
        // Para casos de edição de localidades
        if(id_localidade) obj['id_localidade'] = id_localidade;

        dispatch(
            manutencaoRegioesAddUpdRegiaoLocalidade(obj, Boolean(id_localidade))
        );
    }

    return (
        <Container sx={{py: 1, minHeight: '40vh'}} maxWidth='md'>
            <Typography variant='h6' align='center'>
                Inclusão de nova região / localidade
            </Typography>
            <Typography variant='caption' align='center'>
                Selecione a região e digite a localidade que você deseja incluir no sistema para os candidatos usarem como disponibilidade.
            </Typography>
            <Divider />
            <Grid container spacing={2}>
                <Grid item xs={12} md={12}>
                    <Controller
                            control={control}
                            name='regiao'
                            rules={{required: true}}
                            render={({ field })=>(
                                <Stack sx={{my: 1}}>
                                    <Typography variant='subtitle2' fontWeight='bold' align='left'>Regiões</Typography>
                                    <Select {...field} options={formatarParaSelect(regioes) } 
                                        styles={selectStyles} isDisabled={aguardar}
                                        components={{ NoOptionsMessage }} 
                                        placeholder='Escolha a localidade'
                                    />
                                    {!!errors.regiao && ( <Typography variant='caption' align='center'>Escolha obrigatória</Typography>)}
                                </Stack>
                            )}
                    />
                    <Controller
                        control={control}
                        name='localidade'
                        rules={{required: true}}
                        render={({ field })=>(
                            <TextField label='Localidade' {...field}
                                placeholder='Digite o nome do local'
                                fullWidth sx={{my: 1}} disabled={aguardar}
                                helperText={!!errors.localidade && 'Campo obrigatório'}
                                error={!!errors.localidade}
                                InputLabelProps={{
                                    shrink: true
                                }}
                            />
                        )}
                    />
                </Grid>
                <Hidden mdDown>
                    <Grid item md={4} />
                </Hidden>

                <Grid item xs={12} md={4}>
                    <Button fullWidth variant='contained' 
                        disabled={aguardar}
                        startIcon={aguardar ? <CircularProgress size={20} /> : <SaveIcon />} onClick={handleSubmit(fn)}>
                        SALVAR
                    </Button>
                </Grid>
            </Grid>
        </Container>
    )
}
// Componente para gerar os daos referentes a aba cargos
const AbaCargos = ()=>{
    // Pegar a resolucao da tela para saber em qual estamos trabalhando
    const isMobile = useTheme()?.breakpoints?.values?.sm > window.innerWidth;
    const [busca, setBusca ] = useState('');
    const dispatch = useDispatch();
    const cargos = useSelector(state=> state?.manutencao?.cargos);
    // Filtra os cargos pelo valor do campo de busca e exiba a lista resumida
    const dados = cargos ? cargos?.filter(ele=> ele.cargo.toLowerCase().search( busca.toLowerCase() ) !== -1 ) : [];
    

    return (
        <Container disableGutters={isMobile} sx={{mt: 1}} maxWidth='lg'>
            {isMobile && ( 
                <Fab 
                    color='primary' 
                    aria-label='add' 
                    onClick={()=>{
                        dispatch(manutencaoSetDrawer({tipo: VALORES_DRAWER.ADD_CARGO}));
                    }}
                    sx={{zIndex: 1000, position: 'fixed', right: 16, bottom: 72}}>
                        <AddIcon />
                </Fab> 
            )}
            <PainelAbaCargos
                setBusca={setBusca}
            />
            <List>
                {dados?.map((ele)=>(
                    <ListItemCargos 
                        key={ele.id_cargo}
                        {...ele}
                    />
                ))}
            </List>

        </Container>
    )
}
// Componente para exibir barra de busca e botao para insercao de novos cargos
const PainelAbaCargos = ({ setBusca })=>{
    const dispatch = useDispatch();
    // Estado para recuperar valor
    const [valor, setValor] = useState('');
    const [pesquisa, setPesquisa] = useState(false);
    
    const [ , ] = useDebounce(
        ()=>{
            setBusca(valor);
            setPesquisa(false);
        },
        700,
        [valor]
    );
    //
    const fn = e=>{
        setValor(e.target.value);
        setPesquisa(true);
    }
    // Pegar a resolucao da tela para saber em qual estamos trabalhando
    const values = useTheme()?.breakpoints?.values;
    const isMobile = values?.sm > window.innerWidth;

    return (
        <Stack sx={{mt: 1}} direction='row' alignItems='baseline'>
            <TextField sx={{mx: {md: 1, xs: 0}, mt: 1}}
                type='search' fullWidth
                size='small' label='Pesquisar'
                autoComplete='off'
                onChange={fn}
                value={valor}
                placeholder='Procure por cargo'
                InputProps={{
                    startAdornment: pesquisa ? <CircularProgress sx={{mr: 1}} size={20} /> : <SearchIcon color='primary' />
                }}
            />
             {!isMobile && (
                 <Button sx={{ml: 1}} onClick={()=> dispatch(manutencaoSetDrawer({ tipo: VALORES_DRAWER.INTENCAO_ADD_CARGO })) } 
                    title='Adicionar um novo cargo' size='small' startIcon={<AddIcon />} variant='contained'>
                    ADD
                </Button>
            )}
        </Stack>
    )
}
//
const ListItemCargos = ({ id_cargo, cargo })=>{
    const dispatch = useDispatch();
    const isMobile = useTheme()?.breakpoints?.values?.sm > window.innerWidth;
    const isDark = useTheme().palette.mode === 'dark';
    const [anchorEl, setAnchorEl] = useState('');
    // Esta funcao vai definir que o menu deve ser exibido
    const fnManipularMenu = (evt)=>{
        setAnchorEl(evt.currentTarget);
    }
    // Funcao para fechar o menu
    const fnFecharMenu = ()=> setAnchorEl(null);

    const itensMenu = [
        { titulo: 'Altere o nome do cargo ', onClick: ()=>{
            dispatch(manutencaoSetDrawer({
                tipo: VALORES_DRAWER.INTENCAO_ADD_CARGO,
                valor: { id_cargo, cargo }
            }));
            fnFecharMenu();
        }, icone: <EditIcon />, texto: 'Alterar'},
        { titulo: 'Excluir este cargo (caso não tenha utilização). ', onClick: ()=>{
            dispatch(manutencaoSetDrawer({
                tipo: VALORES_DRAWER.INTENCAO_EXCLUIR_CARGO,
                valor: { id_cargo, cargo }
            }));
            fnFecharMenu();
        }, icone: <DeleteIcon />, texto: 'Excluir'},
    ];
    
    return (
        <ListItem divider>
            <ListItemIcon>
                <EngineeringIcon />
            </ListItemIcon>
            <ListItemText
                primary={cargo} 
            />
              <ListItemSecondaryAction sx={{display: 'flex', flexDirection: 'column'}}>
                {isMobile ? (
                    <IconButton color={isDark ? 'secondary' : 'primary'} onClick={fnManipularMenu}>
                        <MoreVertIcon />
                    </IconButton>
                    ) : (
                    <Button color={isDark ? 'secondary' : 'primary'} onClick={fnManipularMenu} title='Clique aqui para ver as opções disponíveis' startIcon={<MoreVertIcon />} variant='text' size='small'>
                        OPÇÕES
                    </Button>
                    )}
                    <Menu anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={fnFecharMenu}
                        MenuListProps={{ 'aria-labelledby': 'basic-button' }}>
                        {itensMenu.map((ele, idx)=>(
                        <MenuItem title={ele.titulo} key={idx} divider={idx < 2} onClick={ele.onClick}>
                                {ele.icone}
                            <Typography color={ele?.corTexto} sx={{ml: 1}} variant='body2'>
                                {ele.texto}
                            </Typography>
                        </MenuItem>

                        ))}
                    </Menu>            
            </ListItemSecondaryAction> 
        </ListItem>
    );
}
// Componente para exibir formulario para insercao/edicao de cargo
const FormAddUpdCargo = ({ id_cargo, cargo })=>{
    const dispatch = useDispatch();
    const aguardar = useSelector(state=> state?.aguardar);

    const { control, formState: { errors }, handleSubmit } = useForm({
        resolver: yupResolver(schemaAddCargo)
    });

    const fn = val=>{
        const obj = {
            'cargo': val.cargo
        };

        if(id_cargo) obj['id_cargo'] = id_cargo;

        dispatch(
            manutencaoCargoAddUpd(obj, Boolean(id_cargo))
        );
        

    }

    return (
        <Container maxWidth='md'>
            <Stack spacing={2}>
            <Typography align='center' variant='h6'>
               {id_cargo ? 'Editar cargo ' : 'Adicionar novo cargo' }
            </Typography>
            
            <Controller 
                name='cargo'
                control={control}
                defaultValue={cargo}
                rules={{required: true}}
                render={({ field })=>(
                    <TextField type="text" fullWidth size='small'
                        InputLabelProps={{shrink: true }}
                        label='* Cargo (nome)'
                        placeholder='Ex: Auxiliar de vendas'
                        {...field}
                        error={!!errors.cargo}
                        helperText={!!errors.cargo && '* Preenchimento obrigatório'}
                    />

                )}
            />
            <Stack direction='row' justifyContent='center' alignItems={{xs: 'stretch', md: 'center'}}>
                <Button variant='contained' 
                    startIcon={aguardar ? <CircularProgress size={20} /> : (id_cargo ? <EditIcon /> : <AddIcon /> ) } 
                    onClick={handleSubmit(fn)}>
                        {id_cargo ? 'Editar': 'Adicionar'}
                </Button>
            </Stack>
            </Stack>

        </Container>
    )
}
// Componente para a intencao de excluir um cargo
const FormExcluirCargo = ({ id_cargo, cargo })=>{
    const dispatch = useDispatch();
    const aguardar = useSelector(state=> state?.aguardar);

    return (
        <Container maxWidth='md'>
        <Stack spacing={2}>
            <Typography variant='h6' align='center'>
                Exclusão do cargo &nbsp;
                <Typography variant='h6' component='span' color='error'>
                    ({cargo})
                </Typography>
            </Typography>
            <Typography variant='body2' component='p' sx={{opacity: .7}} align='center'>
                Você realmente deseja excluir este cargo ? Ele não ficará mais disponível
            </Typography>
            <Stack direction='row' spacing={1}>
                <Button sx={{flex: 1}} variant='outlined' startIcon={aguardar && <CircularProgress size={20} /> } onClick={()=>{
                    dispatch(
                        manutencaoSetDrawer(null)
                    );
                }}>
                    Cancelar
                </Button>
                <Button sx={{flex: 1}} variant='contained' startIcon={aguardar ? <CircularProgress size={20} /> : <DeleteIcon /> } onClick={()=>{
                    dispatch(
                        manutencaoCargoDel({
                            id_cargo
                        })
                    );
                }}>
                    Excluir
                </Button>
            </Stack>
        </Stack>
        </Container>
    )
}

export default Manutencao;